import { useState, useEffect, useContext } from "react";
import { Input } from "design-react-kit";
import { useLocation, useHistory } from "react-router-dom";
import Repo from "../../Utility/Repo";
import SelectComponent from "../../Components/SelectComponent";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link } from "react-router-dom";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditTicket(props) {
  const apiToken = useContext(TokenContext);
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [user, setUser] = useState(false);
  const [errors, setErrors] = useState({});
  const query = useQuery();
  const history = useHistory();

  const ticketId = query.get("id");
  const userId = query.get("userId");
  useEffect(() => {
    if (!ticketId && !userId) {
      setTicket({
        userId: "",
        richiedente: "",
        categoria: "",
        dettagli: "",
        assegnatoA: "",
      });
      setIsEdit(false);
      setLoading(false);
      return;
    }

    setLoading(true); // Aggiungi il loading prima di iniziare a caricare i dati

    if (ticketId) {
      Repo.getTicket(apiToken, ticketId)
        .then((response) => {
          setTicket(response.data);
          setIsEdit(true);
        })
        .catch((error) => console.error("Errore nel recupero ticket:", error))
        .finally(() => setLoading(false));
    } else if (userId) {
      Repo.getUserOp(apiToken, userId)
        .then((response) => {
          setUser(response.data);
          console.log("response.data", response.data);
          const user = response.data;
          setTicket({
            userId: user.id || "",
            richiedente: user.firstName + " " + user.lastName,
            categoria: "",
            dettagli: "",
            assegnatoA: "",
          });
          setIsEdit(false);
        })
        .catch((error) => {
          console.error("Errore nel recupero dell'operatore:", error);
          setTicket({
            userId: "",
            richiedente: "",
            categoria: "",
            dettagli: "",
            assegnatoA: "",
          });
          setIsEdit(false);
        })
        .finally(() => setLoading(false)); // Imposta lo stato di loading in caso di errore
    }
  }, [apiToken, query.get("id"), query.get("userId")]); // Dipendenze limitate ai valori effettivi

  const ticketStati = [
    { value: 0, label: "Aperto" },
    { value: 1, label: "In Corso" },
    { value: 2, label: "Risolto" },
    { value: 3, label: "Chiuso" },
  ];

  const ticketCategorie = [
    { value: "ANPR", label: "ANPR" },
    { value: "INPS", label: "INPS" },
    { value: "TELEFONO", label: "TELEFONO" },
    { value: "EMAIL", label: "EMAIL" },
    { value: "NOTE", label: "NOTE" },
    { value: "ERRORE", label: "ERRORE" },
  ];

  const handleSubmit = () => {
    const newErrors = {};

    if (!ticket.categoria || ticket.categoria.trim() === "") {
      newErrors.categoria = "Selezionare una categoria.";
    }

    if (!ticket.dettagli || ticket.dettagli.trim() === "") {
      newErrors.dettagli = "Inserire una descrizione.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    if (isEdit) {
      Repo.modificaTicket(apiToken, ticketId, ticket)
        .then(
          () =>
            (window.location.href =
              props.subfolder +
              "/lista_utenti/dati_utente/ticket?userId=" +
              ticket.userId),
        )
        .catch((error) => console.error("Errore aggiornamento ticket:", error));
    } else {
      Repo.postTicket(apiToken, ticket)
        .then(
          () =>
            (window.location.href =
              props.subfolder +
              "/lista_utenti/dati_utente/ticket?userId=" +
              userId),
        )
        .catch((error) => console.error("Errore inserimento ticket:", error));
    }
  };

  const parseAuditDiff = (text) => {
    if (!text) return null;

    const regex = /([^:|.]+):\s*'([^']*)'\s*→\s*'([^']*)'/g;

    const rows = [];
    let match;

    while ((match = regex.exec(text)) !== null) {
      rows.push({
        field: match[1].trim(),
        oldValue: match[2] || "—",
        newValue: match[3] || "—",
      });
    }

    if (rows.length === 0) return null;

    const firstFieldIndex = text.search(regex);

    return {
      header:
        firstFieldIndex > 0 ? text.substring(0, firstFieldIndex).trim() : "",
      rows,
    };
  };

  const audit = parseAuditDiff(ticket?.dettagli);

  if (loading) return <Loader />;

  return (
    <div>
      <h1>{isEdit ? "Modifica ticket" : "Nuovo ticket"}</h1>
      {ticket.assegnato?.trim() !== "" && (
        <h5>Assegnato a: {ticket.assegnatoA}</h5>
      )}

      <div className="col-lg-12 mt-3">
        <div className="card-wrapper card-space">
          <div className="card card-bg no-after card-big roundedCustom">
            <div className="etichetta">
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-user`} />
              </svg>
              <span>
                <Link
                  to={`/lista_utenti/dati_utente?citizen=${ticket.userId}`}
                  className="btn btn-link p-0"
                >
                  {ticket.richiedente}
                </Link>
              </span>
            </div>

            <div className="card-body mt-2">
              <div className="row my-2">
                <div className="col-lg-4">
                  <Input
                    label="Richiedente"
                    value={ticket.richiedente}
                    onChange={(e) =>
                      setTicket({ ...ticket, richiedente: e.target.value })
                    }
                    readOnly={isEdit}
                  />
                </div>
                <div className="col-lg-4">
                  <SelectComponent
                    options={ticketCategorie}
                    value={ticket?.categoria ?? null}
                    onChange={(e) => {
                      setTicket({ ...ticket, categoria: e.value });
                      setErrors((prev) => ({
                        ...prev,
                        categoria: null,
                      }));
                    }}
                    placeholder="Seleziona categoria"
                    isDisabled={ticket?.stato === 2 || ticket?.stato === 3}
                    validation={true}
                    columnClass="col-12"
                  />

                  {errors.categoria && (
                    <small className="text-danger">{errors.categoria}</small>
                  )}
                </div>
                <div className="col-lg-4">
                  {ticket?.stato === 2 || ticket?.stato === 3 ? (
                    <span>
                      {ticketStati.find((s) => s.value === ticket.stato)
                        ?.label || "Stato sconosciuto"}
                    </span>
                  ) : (
                    <SelectComponent
                      options={ticketStati}
                      value={
                        ticket && ticket.stato !== undefined
                          ? ticket.stato
                          : null
                      }
                      onChange={(e) =>
                        setTicket({ ...ticket, stato: parseInt(e.value, 10) })
                      }
                      placeholder="Seleziona stato"
                      isDisabled={!isEdit}
                      validation={true}
                      columnClass="col-12"
                    />
                  )}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-12">
                  <label htmlFor="descrizione">Descrizione:</label>
                  {audit ? (
                    <>
                      <div className="alert alert-success">{audit.header}</div>

                      <table className="table table-sm table-bordered table-hover">
                        <thead>
                          <tr>
                            <th>Campo</th>
                            <th>Valore precedente</th>
                            <th>Nuovo valore</th>
                          </tr>
                        </thead>

                        <tbody>
                          {audit.rows.map((x, i) => (
                            <tr key={i}>
                              <td>
                                <strong>{x.field}</strong>
                              </td>

                              <td>{x.oldValue || "—"}</td>

                              <td>
                                {x.newValue === "—" ? (
                                  <span className="text-muted font-italic">
                                    Mantenuto
                                  </span>
                                ) : (
                                  x.newValue
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    <>
                      <textarea
                        id="descrizione"
                        name="descrizione"
                        value={ticket.dettagli}
                        className={
                          errors.dettagli
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        readOnly={ticket.stato === 2 || ticket.stato === 3}
                        onChange={(e) => {
                          setTicket({ ...ticket, dettagli: e.target.value });
                          setErrors((prev) => ({
                            ...prev,
                            dettagli: null,
                          }));
                        }}
                      />

                      {errors.dettagli && (
                        <div className="invalid-feedback d-block">
                          {errors.dettagli}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-lg-6 text-left">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => history.goBack()}
                  >
                    Indietro
                  </button>
                </div>

                <div className="col-lg-6 text-right">
                  <button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                  >
                    {isEdit ? "Salva Modifiche" : "Crea Ticket"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditTicket;
